import React from 'react';
import { CopilotProvider } from './context/copilot-context';
import { Sidebar } from './components/sidebar';
import { ButtonPortal } from './components/button-portal';
import { CopilotProps } from './types';
import { DEFAULTS } from './utils/config';

export const Copilot: React.FC<CopilotProps> = ({
  theme = DEFAULTS.THEME,
  buttonClassName,
  sidebarWidth = DEFAULTS.SIDEBAR_WIDTH,
  customHeader,
  showCloseButton = true,
  persistHistory = true,
  persistState = true,
  initialMessages = [],
  onOpen,
  onClose,
}) => {
  return (
    <CopilotProvider
      initialTheme={theme}
      persistState={persistState}
    >
      <ButtonPortal />
      <Sidebar
        width={sidebarWidth}
        customHeader={customHeader}
        showCloseButton={showCloseButton}
        persistHistory={persistHistory}
      />
    </CopilotProvider>
  );
};
